import "./OneLeftTwoRightLayoutComponent.scss";
import template from "./OneLeftTwoRightLayoutComponent.html";
import {IComponentOptions} from "angular";
import {BreakpointObserver} from "../../../../../services/breakpoints/BreakpointObserver";
import {Observable} from "rxjs";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {Breakpoint} from "../../../../../services/breakpoints/Breakpoint";

export const OneLeftTwoRight = "tfOneLeftTwoRightLayout";

export function oneLeftTwoRight(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: OneLeftTwoRightLayoutController
    };
}

export class OneLeftTwoRightLayoutController {

    public readonly leftWidgetDisplay$: Observable<WidgetDisplayMode>;
    public readonly rightWidgetsDisplay$: Observable<WidgetDisplayMode>;

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.leftWidgetDisplay$ = this.buildWidgetDisplay();
        this.rightWidgetsDisplay$ = this.buildWidgetDisplay();
    }

    private buildWidgetDisplay(): Observable<WidgetDisplayMode> {
        return this.breakpointObserver
                   .observe(Breakpoint.WebLandscape)
                   .map((bp) => bp.active)
                   .map((active) => active ? WidgetDisplayMode.WIDE : WidgetDisplayMode.TALL)
                   .publishReplay(1)
                   .refCount();
    }
}
